<shared-breadcrumbs [ComponentData]="BreadcrumbsData"></shared-breadcrumbs>

<div class="pg-content__inner">
  <div class="news-crud__heading">
    <div class="pg-wrapper" ngClass="{{(deviceValue | async) === DTypes.Desktop ? 'pt-6 pb-4' : 'pt-4 pb-4'}}">
      <div class="row text-center">
        <h3>Создать новость</h3>
      </div>
    </div>
  </div>

  <div class="news-crud__loading animated faster fadeIn" *ngIf="NewsCrudLoading">
    <div class="ui-loader ui-loader__page-light"></div>
  </div>
  
  <div class="news-crud__content"
    ngClass="{{NewsCrudLoading ? 'loading' : ''}}">

    <div class="pg-wrapper" ngClass="{{(deviceValue | async) === DTypes.Desktop ? 'pt-6 pb-4' : 'pt-4 pb-4'}}">
      <div class="row" [formGroup]="NewsCrudForm"
        ngClass="{{(deviceValue | async) === DTypes.Desktop ? 'mb-6' : 'mb-4'}}">

        <div class="ui-input__placeholder">
          <p>Заголовок:</p>
          <p class="error-holder" *ngIf="ErrorsField.title.status">
            {{ErrorsField.title.value}}
          </p>
        </div>
        <div class="ui-input ui-input__text"
          ngClass="{{ErrorsField.title.status ? 'error' : ''}}">

          <input type="text" placeholder="Заголовок новости" formControlName="title" maxlength="100">
        </div>
        <p class="pt-1 txt-caption">Доступно символов для ввода: {{NewsTitleLimit}}</p>
      </div>

      <div class="row" [formGroup]="NewsCrudForm"
        ngClass="{{(deviceValue | async) === DTypes.Desktop ? 'mb-6' : 'mb-4'}}">

        <div class="ui-input__placeholder">
          <p>Подробный текст:</p>
          <p class="error-holder" *ngIf="ErrorsField.text.status">
            {{ErrorsField.text.value}}
          </p>
        </div>
        <quill-editor class="quill-editor" formControlName="text"
          ngClass="{{ErrorsField.text.status ? 'error' : ''}}">
        </quill-editor>
        <p class="pt-1 txt-caption">Доступно символов для ввода: {{NewsCrudLimit}}</p>
      </div>

      <div class="row" [formGroup]="NewsCrudForm"
        ngClass="{{(deviceValue | async) === DTypes.Desktop ? 'mb-8' : 'mb-4'}}">

        <div class="ui-input__placeholder">
          <p>Изображение:</p>
          <p class="error-holder" *ngIf="ErrorsField.picPath.status">
            {{ErrorsField.picPath.value}}
          </p>
        </div>
        <div class="news-crud__uploader"
          ngClass="{{ErrorsField.picPath.status ? 'error' : ''}}">

          <input type="file" id="previewUpload" class="news-crud__uploader-input" *ngIf="!NewsCrudPreview"
            (change)="onUploadPreviewEvent($event.target['files'])"
            [accept]="fileAcceptString">

          <div class="news-crud__uploader-link" (click)="onUploadPreviewHandler()" *ngIf="!NewsCrudPreview">
            <div class="grid align-items-center justify-content-center">
              <i class="pi pi-upload"></i>
            </div>
          </div>

          <div class="news-crud__uploader-preview" *ngIf="NewsCrudPreview">
            <div class="grid align-items-center justify-content-center">
              <div class="col-8 p-relative">
                <div class="news-crud__uploader-preview__clear" (click)="onRemovePreview()">
                  <i class="pi pi-times-circle"></i>
                </div>
                <img src="{{StaticURL}}{{NewsCrudForm.controls.picPath.value}}">
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row"
        ngClass="{{(deviceValue | async) === DTypes.Desktop ? 'mb-4' : 'mb-4'}}">

        <div class="news-crud__errors __news_crud__errors">
          <div class="grid justify-content-center"
            ngClass="{{(deviceValue | async) === DTypes.Mobile ? 'align-items-center text-left' : 'align-items-baseline'}}">

            <span class="mr-icon mr-icon-status-error"></span>
            <p>{{ErrorsText}}</p>
          </div>
        </div>

        <div class="grid align-items-center justify-content-center">
          <div class="col-4">
            <button class="ui-buttons ui-buttons__blue-large" (click)="onSubmitForm()" pRipple>
              {{NewsCrudDetail ? 'Сохранить новость' : 'Создать новость'}}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
